"use client";

import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Button } from "components/ui/button";
import { useToast } from "components/ui/use-toast";
import { Toaster } from "components/ui/toaster";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "components/ui/form";
import { Input } from "components/ui/input";
import { createExchange } from "api/platformManagement";

const formSchema = z.object({
  name: z.string().min(1).max(50),
  exchangeFee: z.string().min(1).max(50),
});

const ExchangeCompanyForm = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
      exchangeFee: "",
    },
  });

  // 2. Define a submit handler.
  async function onSubmit(values: z.infer<typeof formSchema>) {
    try {
      await createExchange({
        ...values,
        exchangeFee: Number(values.exchangeFee),
      }).then((res) => {
        if (res?.status === 200) {
          navigate("/home/exchange-companies");
        }
      });
    } catch (error) {
      toast({
        title: "Failed to create new exchange company!",
        description: "This is the notification message.",
    
      });
    }
  }

  return (
    <div className="m-auto mt-12 max-w-sm">
      <Form {...form}>
        <div className="flex justify-center">
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-8 pb-6"
          >
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Name</FormLabel>
                  <FormControl>
                    <Input
                      className="w-[280px] lg:w-[350px]"
                      placeholder="Name"
                      {...field}
                    />
                  </FormControl>

                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="exchangeFee"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Exchange Fee (%)</FormLabel>
                  <FormControl>
                    <Input
                      type="number"
                      className="w-[280px] lg:w-[350px]"
                      placeholder="Company Fee"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button
              variant={"secondary"}
              className="w-[280px] lg:w-[350px] border bg-yellow-500 font-bold text-black hover:border-yellow-500 hover:text-white"
            >
              Submit{" "}
            </Button>
          </form>
        </div>
      </Form>

      <Toaster/>
    </div>
  );
};

export default ExchangeCompanyForm;
